module.exports = __webpack_public_path__ + "img/1 to 9-cashflow-after-change.ddbc1ad2.svg";